window.Insurecert = window.Insurecert || {}

class API {

    constructor() { }

    policy(uuid='') {
        if(uuid) { uuid = `${uuid}/` }
        this.url = `/policy/policy/${uuid}`;
        let service = Service(this.url);
        service.host('/');
        return {
            new:(data)=>{
                return service.create(data)
            },
            get: (data) => {
              return service.get(data)
            },
            validate: (data) => {
              return service.get(data,this.url+'validate/');
            },
            save: (data, processData = true) => {
              return service.put(data)
            },
            saveBilling: (data, processData = true) => {
              return service.put(data,this.url+'billing_info/');
            },
            billingInfo: () => {
                return service.get(data,this.url+'billing_info/');
            },
            complete: (data={}) => {
                return service.post(data,this.url+'api_price/');
            },
            pay: (data) => {
                return service.post(data,this.url+'pay/');
            },
            payment_intent: (data)=>{
              return service.post(data,this.url+'payment_intent/');
            },
            get_invoice: (html = false) => {
                return $.ajax({
                    url: this.url + (html ? 'invoice_html/' : 'invoice/'),
                    dataType: (html ? 'text' : 'json'),
                    method: "GET"
                });
            },
            get_certificate_html: () => {
                service.put(data,this.url+'html/');
            },
            submitRequest:(data) =>{
              return service.post(data,this.url+'submit/');
            },
            // GET Request for Broker Info
            getBroker: () => {
              return Service('/api/firstget/')
            },

        }
    }

    registration() {
      let url = `/api/registration/`;
      return {
        register: async function(data) {
          return await Service('auth/create').post(data)
        },
        checkUser:async function(){
          return await Service('auth/user').get()
        },
        login: async function(data) {
          return await Service('auth/login').post(data)
        },
        forgotPassword: async function(data) {
          return await Service('auth/password_reset').post(data)
        },
        resetPassword: async function(data) {
          return await Service('auth/password_reset/reset').post(data)
        },
        policies: Service('dashboard/policies'),
        downloadCustomCertificate:Service('dashboard/policies/:policy_id/download_custom_certificate').download,
      }
    }

    get() {
        return {
            location: (data) => {
              let service = Service('location/location/:location')
              service.host('/')
              return service.get(data);
            },

            geo: () => {
                return {
                    country: (country = 'Canada') => {
                        if( isNaN(parseInt(country)) ){
                            var obj = {
                                url: '/geo/country',
                                dataType: "json",
                                data: {
                                    search: country
                                },
                                method: "GET"
                            };

                            let service = Service(obj.url)
                            service.host('/')
                            return service.get({search:country});
                        }else{
                            var obj = {
                                url: `/geo/country/${country}/`,
                                dataType: "json",
                                method: "GET"
                            };

                            let service = Service(obj.url)
                            service.host('/')
                            return service.get();
                        }
                    },
                    regions: (country) => {
                        var obj = {
                            url: '/geo/region/',
                            dataType: "json",
                            method: "GET"
                        };
                        if (country) {
                            obj.data = {
                                country
                            }
                        }
                        let service = Service(obj.url)
                        service.host('/')
                        return service.get(obj.data)
                    },
                }
            }
        }
    }
}


const HeaderFactory = function(method) {
    let header = {
        'Accept': "application/json",
        'Content-Type': 'application/json'
    };

    let token = localStorage.getItem("insurecert_token");
    if(token) {
        header.Authorization = "JWT " + token;
    }
    return header;
};

export const Service = function(service_url,useAPI=true) {

    function getHostURL() {
      return this._host ? this._host : '/';
    }

    let fetchMethod = async function(service, data, method) {
        let url = service;
        let apiURL = (this._host != undefined) ? this._host : getHostURL.call(API);
        let projectURL = this.namespace && this.project ? `/${this.project}/` : "";
        let api = useAPI ? 'api/':'';
        let serviceURL = "";
        if(!this._external){
            url = `${api}${projectURL}${service}/`;
            url = fillInParsed.call(this, url, data);
            serviceURL = apiURL + url;
        }else {
            serviceURL = fillInParsed.call(this,url, data);
        }
        // auto update to logged in org
        // if(this._org){
        //   serviceUrl += "//api."+get(this._org).api_url  + seviceUrl;
        // }
        if (method == "GET") {
            serviceURL +=
                (url.indexOf("?") === -1 ? "?" : "&") + queryParams(data || {});
            return await fetch(serviceURL, {
                method: method,
                headers: HeaderFactory.call(this),
            }).then(async response => {
                let json;
                if(method == "DOWNLOAD"){
                  json = await response.blob();
                }else{
                  json = await response.json();
                }
                if (response.ok) {
                    return json;
                } else {
                    return { status: response.status, data: json };
                }
            });
        }
        return await fetch(serviceURL, {
            method: method == "DOWNLOAD"?"POST":method,
            headers: HeaderFactory.call(this,method),
            body: (data instanceof FormData) ? data : JSON.stringify(data),
        }).then(async response => {
            let json;
            if(response.status == 204) { //  204 No-Content usually used for delete
                return {"success":true};
            }else {
                if (response.ok) {
                  if(method == "DOWNLOAD"){
                    json = await response.blob();
                  }else{
                    json = await response.json();
                  }
                  return json;
                } else {
                  if(response.status == 500){
                    json = await response.text();
                    return { status: response.status, data: json };
                  }else{
                    json = await response.json();
                    return { status: response.status, data: json };
                  }

                }
            }

        });
    }

    let api = {
        namespace: true,
        project:undefined,
        _host:undefined,
        _contentType:undefined,
        _external:false,
        useNameSpace: function(use) {
            this.namespace = use;
            return this;
        },
        contentType:function(value){
            this._contentType = value;
            return this;
        },
        external:function(value){
            this._external = value;
            return this;
        },
        host: function(value) {
            this._host = value;
            return this;
        },
        varSplitter:function(value){
            this._varSplitter = value;
            return this;
        },
        useProject: function(project) {
            this.project = project;
            return this;
        },
        get: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "GET");
        },
        create: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "POST");
        },
        post: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "POST");
        },
        put: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "PUT");
        },
        update: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "PATCH");
        },
        delete: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "DELETE");
        },
        download: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "DOWNLOAD");
        },
    };
    api.serviceUrl = service_url;
    return api;
};

function fillInParsed(url, data={}) {
    if(this._varSplitter){
        let items = [...url.matchAll(this._varSplitter)];
        for(var i=0;i<items.length;i++){
            let item = items[i]; // match

            let key = item[1];
            if(data[key]){
                url = url.split(item[0]).join(data[key])
            }
        }
        return url;
    }else{
        let items = url.split('/');
        for (var i = 0; i < items.length; i++) {
            let item = items[i];
            if (item.indexOf(":") != -1) {
                item = item.replace(":", "");
                items[i] = data[item] || null;
            }
        }
        return items.join("/").split('//').join('/');
    }
}

function queryParams(params) {
    let keys = []
    if(params instanceof FormData){
        keys = params.keys()
    }else{
        keys = Object.keys(params);
    }
    return keys.map(k => encodeURIComponent(k) + "=" + encodeURIComponent(getValue(k,params))) .join("&");
}


function getValue(key,data){
    if(data instanceof FormData) {
        return data.get(key)
    }else{
        return data[key]
    }
}

function removeKey(key,data){
    if(data instanceof FormData) {
        delete data.delete(key);
    }else{
        delete data[key];
    }
}



export const to = function(promise) {
    return promise
        .then(
            data => {
                if (
                    data.error ||
                    data.status == 401 ||
                    data.status == 403 ||
                    data.status == 405 ||
                    data.status == 400 ||
                    data.status == 500 ||
                    data.status == 404
                ) {
                  console.log('error',data)
                    return [data, null];
                }
                return [null, data];
            },
            error => {
                return [error];
            }
        )
        .catch(err => [err]);
};


window.Insurecert.API = new API();
